import {
  UPDATE_COURSE_ERROR,
  UPDATE_COURSE_SUCCESS,
} from "../../actionTypes/authActionTypes";

const reducer = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_COURSE_SUCCESS:
      return {
        ...state,
        updateCourseData: action.payload,
      };
    case UPDATE_COURSE_ERROR:
      return {
        ...state,
        updateCourseError: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
